import React from 'react'

export default props => (
    <footer className='main-footer'>
	{/* <strong>Copyrigth &copy; 2021</strong>
	<a href='http://www.google.com.br' target='_blank'> Google</a>.*/}
    </footer>
)


// WEBPACK FOOTER //
// ./src/common/template/footer.jsx